import { useLang } from "@/context/LanguageContext";
import { CONTACT_INFO } from "@/data/content";
import Logo from "@/components/Logo";

const NAV_LINKS = ["about", "services", "projects", "team", "insights", "faq", "contact"];

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-[color:var(--anthracite)] text-[color:var(--bone)] border-t border-[color:var(--copper)]/20" data-testid="site-footer">
      <div className="container-lux py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo tone="light" size={56} />
            <p className="mt-6 font-serif-display italic text-[20px] leading-[1.35] text-[color:var(--bone)]/85 max-w-sm">
              {t.footer.tagline}
            </p>
            <p className="mt-5 text-[13px] leading-[1.7] text-[color:var(--bone)]/50 max-w-sm">
              {t.footer.registered}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--bronze)]">
              {t.footer.quick_links}
            </div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((k) => (
                <li key={k}>
                  <button
                    onClick={() => scrollTo(`#${k}`)}
                    className="text-[14px] text-[color:var(--bone)]/75 hover:text-[color:var(--bronze)] transition-colors"
                    data-testid={`footer-link-${k}`}
                  >
                    {t.nav[k]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--bronze)]">
              {t.footer.contact_label}
            </div>
            <div className="mt-5 space-y-3 text-[14px] text-[color:var(--bone)]/75">
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                className="block hover:text-[color:var(--bronze)] transition-colors"
                data-testid="footer-email"
              >
                {CONTACT_INFO.email}
              </a>
              {CONTACT_INFO.phones.map((p) => (
                <a
                  key={p.number}
                  href={`tel:${p.number.replace(/\s/g, "")}`}
                  className="block hover:text-[color:var(--bronze)] transition-colors"
                  data-testid={`footer-phone-${p.label}`}
                >
                  <span className="text-[color:var(--bronze)] me-2">{p.label} ·</span>
                  {p.number}
                </a>
              ))}
              <div className="pt-3 leading-[1.6] text-[color:var(--bone)]/55">
                {CONTACT_INFO.address}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[color:var(--copper)]/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--bone)]/45">
            © {year} · TA Clé Invest Gayrimenkul Yatırım ve Finans A.Ş. · {t.footer.rights}
          </div>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--bone)]/45">
            Zug · İstanbul · Ege
          </div>
        </div>
      </div>
    </footer>
  );
}
